module.exports = __webpack_public_path__ + "img/edge_activites_activites_culturelles.d4a5351c.svg";